import { PERMISSIONS } from '@erp/shared';
import { useMemo, useState } from 'react';
import { usePermissions } from '@/features/auth';
import { useSalesTask } from '@/features/sales-assistant/api/use-sales-assistant';
import { TaskOutcomeDialog } from '@/features/sales-assistant/components/sales-action-dialogs';
import { usePendingSalesCallOutcomes } from '@/features/telephony/api/use-telephony';

/** Öffnet nach einem verknüpften CTI-Ruf genau den vorhandenen Ergebnisworkflow. */
export function SalesCtiOutcomeOverlay(): JSX.Element | null {
  const permissions = usePermissions();
  const enabled =
    permissions.canAccess('TELEPHONY', 'USE') &&
    permissions.can(PERMISSIONS.SALES_ASSISTANT_USE) &&
    permissions.can(PERMISSIONS.SALES_TASKS_VIEW_OWN) &&
    permissions.can(PERMISSIONS.SALES_CONTACTS_DOCUMENT);
  const outcomes = usePendingSalesCallOutcomes(enabled);
  const [dismissed, setDismissed] = useState<ReadonlySet<string>>(new Set());
  const pending = useMemo(
    () => outcomes.data?.find((candidate) => !dismissed.has(candidate.communicationLogId)) ?? null,
    [dismissed, outcomes.data],
  );
  const task = useSalesTask(pending?.salesTaskId ?? '', pending !== null);

  if (pending === null || task.data === undefined) return null;
  const dismiss = (): void => {
    setDismissed((current) => new Set([...current, pending.communicationLogId]));
  };

  return (
    <TaskOutcomeDialog
      task={task.data}
      initialOutcome={
        pending.status === 'MISSED' || pending.status === 'FAILED' ? 'NOT_REACHED' : 'REACHED'
      }
      direction={pending.direction}
      occurredAt={pending.endedAt}
      idempotencyKey={`cti-outcome-${pending.communicationLogId}`}
      onSuccess={dismiss}
      onOpenChange={(open) => {
        if (!open) dismiss();
      }}
    />
  );
}
